<template>
  <div
    :class="{
      leftMenu: true,
      leftMenuTwo: isMode != 'none',
      leftMenuThree: isMode == 'Hide',
      leftMenuFour: $route.name == 'notice',
    }"
  >
    <div class="topBox">
      <img
        @click="goHome()"
        class="logo"
        v-show="isMode == 'none'"
        :src="
          $utils.getPng(
            $store.state.theme == 'light'
              ? 'icon-gfans-logo'
              : 'icon-gfans-logo-dark'
          )
        "
        alt=""
      />
      <img
        @click="goHome()"
        class="logoTwo"
        v-show="isMode != 'none'"
        :src="
          $utils.getPng(
            $store.state.theme == 'light'
              ? 'icon-gfans-logoTwo'
              : 'icon-gfans-logoTwo-dark'
          )
        "
        alt=""
      />
    </div>
    <div class="bottomBox">
      <div
        v-for="item in menuList"
        :key="item.id"
        class="menuItem"
        :class="{
          active: activeMenu === item.id,
        }"
        @click="selectMenu(item)"
      >
        <svg-btn class="icon" :icon-class="getIconClass(item)"></svg-btn>
        <div class="font" v-show="isMode == 'none'">
          <el-badge
            :hidden="$store.state.collectTotal == 0"
            v-show="item.id == 2"
            :value="$store.state.collectTotal"
            :max="99"
          >
            <span class="fontS">{{ item.name }}</span>
          </el-badge>
          <span v-show="item.id != 2" class="fontS">{{ item.name }}</span>
        </div>
      </div>
      <div
        @click="release"
        class="releaseBtn primaryBtn"
        v-show="isMode == 'none'"
      >
        发布
      </div>
      <div @click="release" class="addBtn" v-show="isMode != 'none'">
        <svg-btn class="bgIcon" icon-class="icon-releaseBt"> </svg-btn>
        <svg-btn class="centerIcon" icon-class="icon-releaseBt-add"> </svg-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from '@/utils/event-bus'
export default {
  props: {
    isMode: {
      type: String,
      default: 'none',
    },
  },
  data() {
    return {
      activeMenu: 1,
      menuList: [
        { id: 1, name: '订阅', icon: 'icon-menu1' },
        { id: 2, name: '收藏', icon: 'icon-menu2' },
      ],
    }
  },
  watch: {
    // 监听路由变化
    $route() {
      this.setActiveMenu()
    },
  },
  created() {
    this.setActiveMenu()
  },
  mounted() {
    // 监听头部选择订阅/收藏跳转时间
    eventBus.$on('checkLeftMenu', num => {
      this.activeMenu = num
    })
  },
  beforeDestroy() {
    eventBus.$off('checkLeftMenu')
  },
  methods: {
    setActiveMenu() {
      if (this.$route.name === 'home') {
        this.activeMenu = 1
      } else if (this.$route.name === 'collect') {
        this.activeMenu = 2
      }
      // this.activeMenu = this.$route.name === 'collect' ? 2 : 1
    },
    getIconClass(item) {
      if (this.activeMenu === item.id) {
        return item.icon + (this.$store.state.theme === 'light' ? '-a' : '-b')
      }
      return item.icon
    },
    goHome() {
      // if (this.$store.state.isLogin == 0) {
      //   eventBus.$emit('showLogin', {})
      //   return
      // }
      this.activeMenu = 1
      if (this.$store.state.isLogin == 0) {
        this.$router.push({ path: '/discover' })
      } else {
        this.$router.push({ path: '/subscribe' })
      }
    },
    selectMenu(item) {
      if (item.id != 1 && this.$store.state.isLogin == 0) {
        eventBus.$emit('showLogin', {})
        return
      }
      this.activeMenu = item.id
      if (item.id == 1) {
        if (this.$store.state.isLogin == 0) {
          this.$router.push({ path: '/discover' })
        } else {
          this.$router.push({ path: '/subscribe' })
        }
      } else {
        this.$router.push('/collect')
      }
    },
    //发布
    release() {
      if (this.$store.state.isLogin == 0) {
        eventBus.$emit('showLogin', {})
        return
      }
      window.open(
        this.$glb.upJmdyhUrl +
          `/subscribe?platfro=${localStorage.getItem('platfro')}`,
        '_blank'
      )
    },
  },
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
